import { fetcher } from "../../utils/fetcher.js";

// Banners to show to the logged-in user
export const getSystemBanners = () => fetcher.get("/api/system-banners");

// All banners, including inactive and ended ones (super admin)
export const getAllSystemBanners = () => fetcher.get("/api/system-banners/all");
